import { ApolloLink, Operation, NextLink } from '@apollo/client';
import { AUTH_TOKEN } from '../../constants';

export const authLink = new ApolloLink((operation: Operation, forward: NextLink) => {
  const token = sessionStorage.getItem(AUTH_TOKEN) || localStorage.getItem(AUTH_TOKEN);

  operation.setContext({
    headers: {
      authorization: `Bearer ${token}`
    }
  });

  return forward(operation);
});